@if (opened) {
<div>
  <mat-list dense style="padding: 0">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title> Notes: </mat-panel-title>
      </mat-expansion-panel-header>
      @if (patient) {
      <mat-form-field floatLabel="never" appearance="fill">
        <textarea
          matInput
          placeholder="Add new note"
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="3"
          [(ngModel)]="patient.patientNote"
        ></textarea>
      </mat-form-field>
      }
      <app-progress-button
        class="float-right"
        [submitting]="submitting"
        (submit)="saveNote()"
        [disabled]="patient.patientNote === noteInitialValue"
        text="Save note"
      ></app-progress-button>
    </mat-expansion-panel>
  </mat-list>
</div>
}
